<template src="./AcessoRealtec.html"/>
<style src="./AcessoRealtec.css"></style>

<script>
import Filter from "@/components/AcessoRealtec/Filter/Filter";
import Data from "@/components/AcessoRealtec/Data/Data";

import store from "@/store";

export default {
  components: {
    "app-component-acesso-realtec-filter": Filter,
    "app-component-acesso-realtec-data": Data    
  },
  data(){
    return {            
    }
  },
  created(){    
  },
  methods: {
    onResize() {
      store.dispatch("setWindowWidth", window.innerWidth);
      store.dispatch("setWindowHeight", window.innerHeight);
    }
  },
  computed: {
    snackBar() {
      return store.state.acessoRealtec.snackBar;
    }
  }
};
</script>

